import type { ReactNode, JSX } from 'react';
import { formatNumberToCurrency, formatTimeToDate } from 'utils/app';

/**
 * 受診者詳細ヘッダー共通コンポーネント（Quiz/Diagnosis/Form 共通）
 * タイトル + 作成日 + 公開期間 + StatusBadge + リスト数 + リスト出力
 */
export default function WsRespondentDetailHeader(props: {
  title: string;
  createdAt: number;
  createdAtLabel: string;
  publishTerm: string;
  statusBadge: ReactNode;
  respondentCount: number;
  onBack: () => void;
  onModalReportDownloadOpen: () => void;
}): JSX.Element {
  const {
    title,
    createdAt,
    createdAtLabel,
    publishTerm,
    statusBadge,
    respondentCount,
    onBack,
    onModalReportDownloadOpen,
  } = props;

  return (
    <section className="section-header user-detail">
      <div className="container">
        <a onClick={onBack} className="btn-back-list hover">
          戻る
        </a>

        <div className="card card-detail">
          <div className="card-body">
            <div className="d-md-flex d-flex-detail">
              <div className="flex-shrink-0 flex-left">
                <h2 className="flex-title">{title}</h2>
                <ul className="list-unstyled list-inline">
                  <li className="list-inline-item">
                    {createdAtLabel}：{formatTimeToDate(createdAt, 'yyyy/MM/dd')}
                    <br className="d-md-none" />
                    公開期間：{publishTerm}
                  </li>
                  <li className="list-inline-item">{statusBadge}</li>

                  <li className="list-inline-item">
                    リスト数：{`${formatNumberToCurrency(respondentCount)}件`}
                  </li>
                </ul>
              </div>
              <div className="flex-grow-1 flex-right">
                <a
                  onClick={onModalReportDownloadOpen}
                  className="btn btn-common btn-common-w238 moderate-blue"
                >
                  リスト出力
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
